import { render } from "./ResidualOilComposition.vue?vue&type=template&id=12cb8bea&scoped=true"
import script from "./ResidualOilComposition.vue?vue&type=script&lang=js"
export * from "./ResidualOilComposition.vue?vue&type=script&lang=js"

import "./ResidualOilComposition.vue?vue&type=style&index=0&id=12cb8bea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cb8bea"]])

export default __exports__